import React from 'react';
import { useQuotedMessage } from '../context/QuotedMessageContext';
import CloseIcon from '@mui/icons-material/Close';
import ReplyIcon from '@mui/icons-material/Reply';
import './QuotedMessagePreview.scss';

export const QuotedMessagePreview: React.FC = () => {
  const { quotedMessage, clearQuotedMessage } = useQuotedMessage();

  if (!quotedMessage) return null;

  const messageText = quotedMessage.text || '';
  const senderName = quotedMessage.user?.name || quotedMessage.user?.id || 'Unknown';
  
  // Truncate long messages
  const truncatedText = messageText.length > 100 
    ? messageText.substring(0, 100) + '...' 
    : messageText;

  return (
    <div className="quoted-message-preview">
      <div className="quoted-message-preview__icon">
        <ReplyIcon />
      </div>
      <div className="quoted-message-preview__content">
        <div className="quoted-message-preview__sender">{senderName}</div>
        <div className="quoted-message-preview__text">{truncatedText || 'Attachment'}</div>
      </div>
      <button 
        className="quoted-message-preview__close"
        onClick={clearQuotedMessage}
        aria-label="Cancel reply"
      >
        <CloseIcon />
      </button>
    </div>
  );
};

